import B3Request from '@/shared/service/request/b3Fetch';
import { CompanyType } from '@/types/gql/graphql';

interface MasqueradeUserResponse {
  superAdminMasquerading: CompanyType;
}

interface NormalUserResponse {
  userCompany: CompanyType;
}

interface DataInput {
  userId: number | undefined;
}

const getMasqueradeUser = `
  query userCompany($userId: Int!) {
    superAdminMasquerading(customerId: $userId) {
      companyName
      addressLine1
      addressLine2
      city
      zipCode
      state
      country
      extraFields {
        fieldName
        fieldValue
      }
    }
  }
`;

const getNormalUser = `
  query userCompany($userId: Int!) {
    userCompany(userId: $userId) {
      companyName
      addressLine1
      addressLine2
      city
      zipCode
      state
      country
      extraFields {
        fieldName
        fieldValue
      }
    }
  }
`;

export const getMasqueradeUserInfo = async (data: DataInput): Promise<MasqueradeUserResponse> =>
  B3Request.graphqlB2B({
    query: getMasqueradeUser,
    variables: data,
  });

export const getNormalUserInfo = async (data: DataInput): Promise<NormalUserResponse> =>
  B3Request.graphqlB2B({
    query: getNormalUser,
    variables: data,
  });
